import * as React from 'react';
import * as ReactDOM from 'react-dom';

import KendoBaseComponent, { KendoWidgetProps } from '@progress/kendo-base-component-react-wrapper';

export interface PanelBarProps extends KendoWidgetProps, kendo.ui.PanelBarOptions {
    children?: React.ReactNode;
}

export default class PanelBar extends KendoBaseComponent<PanelBarProps, {}> {
    componentDidMount(): void {
        const domNode = this.domNode;
        const { children, widgetRef, ...props } = this.props;

        if (domNode) {
            this.widgetInstance = new kendo.ui.PanelBar(domNode as Element, (props as kendo.ui.PanelBarOptions));
            super.componentDidMount();
        }
    }

    render(): any {
        if (this.didMount) {
            const { children, widgetRef, ...props } = this.props;
            const widget = (this.widgetInstance as kendo.ui.PanelBar);

            if (props.dataSource && props.dataSource === widget.options.dataSource) {
                delete props.dataSource;
            }
            this.widgetInstance.setOptions(props);
        }

        return (
            <ul ref={this.elementRef}>
                {this.props.children}
            </ul>
        );
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-react-wrapper/src/panelbar/index.tsx